import { QUERY_KEY } from 'constants/globalConstants'
import ApiService from 'apiService'
import { useQuery } from 'react-query'

const useEntityListName = () => {
    return useQuery(QUERY_KEY.GET_ENTITY_LIST_NAME, () => ApiService.getEntityNameList(), {retry: false})
}

export default useEntityListName